module.exports = __webpack_public_path__ + "img/preview.68267a43.png";